<template>
    <div class="" data-cy="container_survey_welcome">
        <div class="" :style="{ '--logo-welcome-url': 'url(' + getWelcomeLogoImage() + ')' }">
            <div class="pt-6 px-4">
                <img class="w-[160px] h-10" :src="getLogoImage()" alt="">
            </div>

            <div class="pt-8 px-4 pb-8 mb-[140px]">
                <div class="font-medium text-32 px-4" v-html="lbl.golden_question.welcome.title"></div>
                <div class="relative pb-56">
                    <div class="pt-4 px-4" v-html="lbl.golden_question.welcome.message"></div>
                    <div class="absolute left-4 top-44">
                        <img class="w-[178px] h-[110px]" :src="getOtterImage()" alt="">
                    </div>
                    <div class="absolute left-48 top-24">
                        <img class="w-[140px] h-[150px]" :src="getCatImage()" alt="">
                    </div>
                </div>
                <div class="pt-2">
                    ข้อกำหนดและเงื่อนไขของภารกิจพิเศษ
                    <br><br>
                    1.&nbsp;สิทธิพิเศษนี้สำหรับลูกค้าโมบายแบงก์กิ้งธนาคารกรุงเทพ<br>
                    2.&nbsp;ทำแบบทดสอบเสร็จ รับ 50 แพลงก์ตอน/ท่าน ตลอดระยะเวลาโครงการ<br>
                    3.&nbsp;ระยะเวลาโครงการสำหรับภารกิจนี้ ตั้งแต่วันที่ 1 ตุลาคม 2568 ถึง 31 ธันวาคม 2568<br><br>
                    ทั้งนี้ แบบสอบถามและคำตอบของคุณจะถูกเก็บเป็นความลับ โดยข้อมูลจะถูกนำไปใช้เพื่อวัตถุประสงค์ในการศึกษาความสนใจของคุณและนำมาปรับปรุงพัฒนาผลิตภัณฑ์/บริการ รวมถึงแนวทางการนำเสนอผลิตภัณฑ์/บริการที่น่าจะเหมาะสมกับคุณ เท่านั้น
                    <br><br>
                    การเข้าร่วมเล่นภารกิจนี้ถือว่าคุณได้ตกลงยินยอมตามข้อกำหนดและเงื่อนไขข้างต้นของธนาคารกรุงเทพแล้ว
                </div>
            </div>
            <div class="fixed bottom-0 w-full flex flex-col gap-4 pt-4 px-4 pb-8 bg-white max-w-[500px]">
                <div class="w-full bg-a-blue-0064ff flex justify-center items-center text-white font-medium rounded-xl px-6 py-3.5" data-cy="btn_survey_welcome_start" @click="goNextStep()">
                    {{ lbl.golden_question.welcome.start }}
                </div>
                <div class="text-center font-medium" data-cy="btn_survey_welcome_exit" @click="$router.replace('/')">
                    {{ lbl.golden_question.welcome.exit }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    name: 'Welcome',
    mixins: [LocaleMixin],
    methods: {
        goNextStep: function() {
            this.$emit('setStep', 'question');
        },
        imgUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/golden-question/`;
        },
        getLogoImage: function() {
            return this.imgUrl() + 'logo-bbl.svg';
        },
        getOtterImage: function() {
            return this.imgUrl() + 'logo-otter.png';
        },
        getCatImage: function() {
            return this.imgUrl() + 'logo-cat.png';
        },
        getWelcomeLogoImage: function() {
            return this.imgUrl() + 'logo-welcome.png';
        }
    }
}
</script>
<style scoped lang="scss">
@import "@/style/base/image.scss";
.logo-welcome {
    @include boxRatio($ratio: 100%);
    background-image: var(--logo-welcome-url);
    background-repeat: no-repeat;
    background-size: 358px 310px;
    background-position: top center;
}
</style>